function Error(){
    return(
        <div className={"mt-5 card justify-contents-center text-center"}>
            <h3 className={"card-title"}>Session error</h3>
            <div className={"card-body"}>You have been automatically logged out!<div><button className={"btn btn-primary mt-2"} onClick={()=>{window.location.href="/"}}>Ok</button></div></div>
        </div>
    )
}
export default Error;
